import { render, staticRenderFns } from "./bankcard.vue?vue&type=template&id=a5994b16&scoped=true&"
import script from "./bankcard.vue?vue&type=script&lang=js&"
export * from "./bankcard.vue?vue&type=script&lang=js&"
import style0 from "./bankcard.vue?vue&type=style&index=0&id=a5994b16&scoped=true&lang=css&"
import style1 from "./bankcard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5994b16",
  null
  
)

export default component.exports